import { APP_LOGO, PROJECT_NAME } from '../config/Constant';
import './Loader.css';

const Loader = () => (
  <div className="hz-loader-overlay">
    <div className="hz-loader-core">
      {/* Logo with orbital rings */}
      <div className="hz-loader-ring-wrap">
        <div className="hz-loader-ring" />
        <div className="hz-loader-ring-inner" />
        <img
          src={APP_LOGO}
          alt={PROJECT_NAME}
          className="hz-loader-logo"
          draggable={false}
        />
      </div>

      {/* Shimmer progress indicator */}
      <div className="hz-loader-shimmer-track">
        <div className="hz-loader-shimmer-bar" />
      </div>

      <span className="hz-loader-label">{PROJECT_NAME}</span>
    </div>
  </div>
);

export default Loader;
